import {ModelSetOptions} from 'backbone';

import * as navigation from 'Navigation';

export interface ProteinEntityStructureTabStateAttributes {
  proteinId: string;
  isEditable: boolean;
}

interface ProteinEntityStructureTabState {
  get<K extends keyof ProteinEntityStructureTabStateAttributes>(
    key: K
  ): ProteinEntityStructureTabStateAttributes[K];
  set<K extends keyof ProteinEntityStructureTabStateAttributes>(
    attributeName: K,
    value: ProteinEntityStructureTabStateAttributes[K],
    options?: ModelSetOptions
  ): ProteinEntityStructureTabState;
  set(obj: Partial<ProteinEntityStructureTabStateAttributes>): ProteinEntityStructureTabStateAttributes;
}

class ProteinEntityStructureTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: '3D Structure',
      closeable: false,
      preferenceKey: 'protein-entity-structure',
    };
  }
}

export default ProteinEntityStructureTabState;
